import { Component, Vue } from 'vue-property-decorator';

import { BrochureDeepLinkBlockViewModel } from './BrochureDeepLinkModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import BrochureDeepLinkCard from './BrochureDeepLinkCard/BrochureDeepLinkCard.vue';
import DownloadGateMixin from '@/mixins/DownloadGateMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    BrochureDeepLinkCard,
  },
  props: getComponentProps<BrochureDeepLinkBlockViewModel>({
    Title: 'View our brochure for more details',
    Brochures: []
  }),
})
export default class BrochureDetailModule extends mixins(DownloadGateMixin) {
  p!: BrochureDeepLinkBlockViewModel;
  showAll = false;
  get cards() {
    if (!this.showAll) return this.p.Brochures.slice(0, 3)
    return this.p.Brochures
  }
  loadMore() {
    this.showAll = true
  }
}
